// /payout-definitions
import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { Option, Pagination, PaginationParams } from '@/common/types';
import { API_URL } from '@/dtos';
import { useCurrentOrganization } from '@/modules/core/hooks';
import { ROOT_ORGANIZATION } from '@/modules/ProcessingDefinition/ProcessingDefinition.constants';
import {
  PayoutDefinition,
  PayoutDefinitionResponse,
} from '@/modules/ProcessingDefinition/ProcessingDefinition.types';
import { CATEGORY_LABELS } from '@/modules/ProcessingDefinition/Services/Services.constants';

export const QUERY_KEY = 'GET_PAYOUT_DEFINITIONS';
export default (
  params?: PaginationParams,
  page?: number,
  name?: string,
  id?: string,
  isLimitedUse?: boolean
) => {
  const { observingOrganization } = useCurrentOrganization();
  const { data, isLoading } = useQuery(
    [QUERY_KEY, page, observingOrganization.path, params, name, id, isLimitedUse],
    () =>
      // TODO: the dto type is missing
      api.get<Pagination<PayoutDefinitionResponse>>(API_URL.PAYOUT_DEFINITIONS, {
        params: {
          organization_path: observingOrganization.path || ROOT_ORGANIZATION,
          size: params?.perPage || 50,
          page: page || (params?.page ? params.page - 1 : 0),
          name: name || params?.searchString,
          sort: params?.sort,
          id,
          is_limited_use: isLimitedUse,
        },
      })
  );
  const fieldOptions = useMemo<Option[]>(() => {
    const list = data?.data.content || [];
    return list.map((item) => ({
      key: `${item.id}`,
      value: `${item.id}`,
      title: item.name,
    }));
  }, [data]);
  const formatedData = useMemo<PayoutDefinition[]>(
    () =>
      (data?.data.content || []).map((item) => ({
        id: `${item.id}`,
        name: item.name,
        categoryTypesStrings: item?.categories?.map(
          (el) => CATEGORY_LABELS[el?.category_type] || el?.category_type
        ),
        isLimited: item.is_limited_use ?? false,
        organizationType: item.organization_type,
      })),
    [data]
  );
  return {
    fieldOptions,
    formatedData,
    isLoading,
    page: data?.data?.number,
    total: data?.data.totalElements || 0,
    totalPages: data?.data.totalPages || 0,
  };
};
